import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './components/Login';
import Signup from './components/Signup';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import TaskBoardManager from './pages/TaskBoardManager';
import Whiteboard from './pages/Whiteboard';
import CustomWhiteboard from './pages/CustomWhiteboard';
import PRDWriter from './pages/PRDWriter';
import MeetingPlan from './pages/MeetingPlan';
import Templates from './pages/Templates';
import Settings from './pages/Settings';
import DocumentEditor from './pages/DocumentEditor';
import GoogleCallback from './pages/GoogleCallback';
import MicrosoftCallback from './pages/MicrosoftCallback';
import MeetingDetailsPage from './pages/MeetingDetailsPage';
import FeatureStudio from './pages/FeatureStudio';
import Users from './pages/Users';
import Companies from './pages/Companies';
import CustomerUsers from './pages/CustomerUsers';
import ProductInsights from './pages/product/Insights';
import ProductPrioritize from './pages/product/Prioritize';
import ProductFeatures from './pages/product/Features';
import ProductInitiatives from './pages/product/Initiatives';
import ProductReleases from './pages/product/Releases';
import ProductObjectives from './pages/product/Objectives';
import Onboarding from './pages/Onboarding';
import OnboardingTasks from './pages/OnboardingTasks';
import OnboardingForms from './pages/OnboardingForms';
import FormBuilder from './pages/FormBuilder';
import OnboardingInvoicing from './pages/OnboardingInvoicing';
import OnboardingDocuments from './pages/OnboardingDocuments';
import DocumentTemplateEditor from './pages/DocumentTemplateEditor';
import OnboardingTemplates from './pages/OnboardingTemplates';
import OnboardingTemplateBuilder from './pages/OnboardingTemplateBuilder';
import AcceptInvite from './pages/AcceptInvite';
import AuthCallback from './pages/AuthCallback';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Public pages — no auth guard */}
          <Route path="/invite/:token" element={<AcceptInvite />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/onboarding/tasks" element={<ProtectedRoute permission="onboarding"><OnboardingTasks /></ProtectedRoute>} />
          <Route path="/onboarding/forms" element={<ProtectedRoute permission="onboarding"><OnboardingForms /></ProtectedRoute>} />
          <Route path="/onboarding/forms/new" element={<ProtectedRoute permission="onboarding"><FormBuilder /></ProtectedRoute>} />
          <Route path="/onboarding/forms/:id/edit" element={<ProtectedRoute permission="onboarding"><FormBuilder /></ProtectedRoute>} />
          <Route path="/onboarding/invoicing" element={<ProtectedRoute permission="onboarding"><OnboardingInvoicing /></ProtectedRoute>} />
          <Route path="/onboarding/templates" element={<ProtectedRoute permission="onboarding"><OnboardingTemplates /></ProtectedRoute>} />
          <Route path="/onboarding/templates/:id/edit" element={<ProtectedRoute permission="onboarding"><OnboardingTemplateBuilder /></ProtectedRoute>} />
          <Route path="/onboarding/documents" element={<ProtectedRoute permission="onboarding"><OnboardingDocuments /></ProtectedRoute>} />
          <Route path="/onboarding/documents/:id/edit" element={<ProtectedRoute permission="onboarding"><DocumentTemplateEditor /></ProtectedRoute>} />
          <Route path="/onboarding/:section" element={<ProtectedRoute permission="onboarding"><Onboarding /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute permission="users"><Users /></ProtectedRoute>} />
          <Route path="/customers/companies" element={<ProtectedRoute permission="customers"><Companies /></ProtectedRoute>} />
          <Route path="/customers/users" element={<ProtectedRoute permission="customers"><CustomerUsers /></ProtectedRoute>} />
          <Route path="/product/insights" element={<ProtectedRoute permission="product_insights"><ProductInsights /></ProtectedRoute>} />
          <Route path="/product/prioritize" element={<ProtectedRoute permission="product_prioritize"><ProductPrioritize /></ProtectedRoute>} />
          <Route path="/product/features" element={<ProtectedRoute permission="product_features"><ProductFeatures /></ProtectedRoute>} />
          <Route path="/product/initiatives" element={<ProtectedRoute permission="product_initiatives"><ProductInitiatives /></ProtectedRoute>} />
          <Route path="/product/releases" element={<ProtectedRoute permission="product_releases"><ProductReleases /></ProtectedRoute>} />
          <Route path="/product/objectives" element={<ProtectedRoute permission="product_objectives"><ProductObjectives /></ProtectedRoute>} />
          <Route path="/taskboards" element={<ProtectedRoute><TaskBoardManager /></ProtectedRoute>} />
          <Route path="/taskboard/:id" element={<ProtectedRoute><TaskBoardManager /></ProtectedRoute>} />
          <Route path="/whiteboards" element={<ProtectedRoute><Whiteboard /></ProtectedRoute>} />
          <Route path="/custom-whiteboard" element={<ProtectedRoute><CustomWhiteboard /></ProtectedRoute>} />
          <Route path="/docs-writer" element={<ProtectedRoute><PRDWriter /></ProtectedRoute>} />
          <Route path="/doc-editor/:id" element={<ProtectedRoute><DocumentEditor /></ProtectedRoute>} />
          <Route path="/meeting-plan" element={<ProtectedRoute><MeetingPlan /></ProtectedRoute>} />
          <Route path="/meeting/:id" element={<ProtectedRoute><MeetingDetailsPage /></ProtectedRoute>} />
          <Route path="/feature-studio" element={<ProtectedRoute><FeatureStudio /></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/auth/google/callback" element={<ProtectedRoute><GoogleCallback /></ProtectedRoute>} />
          <Route path="/auth/microsoft/callback" element={<ProtectedRoute><MicrosoftCallback /></ProtectedRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
